"use client";

import { trackEvent } from "@/lib/tracking";

interface TrackedLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    eventName: string;
    eventParams: Record<string, any>;
    children: React.ReactNode;
}

export function TrackedLink({ eventName, eventParams, children, ...props }: TrackedLinkProps) {
    const handleClick = () => {
        trackEvent(eventName, eventParams);
    };

    return (
        <a {...props} onClick={handleClick}>
            {children}
        </a>
    );
}
